import { useUser } from '@auth-v2';
import { useMutation, useQuery } from '@tanstack/react-query';

import { apiClient, ApiConfig, getLiveAnalysisEnabled } from '@data';

import { queryClient } from '../config';

export const getLiveAnalysisEnabledKey = () => ['live-feedback', 'enabled'];

export const useLiveAnalysisEnabled = () => {
    const { data: user } = useUser();
    return useQuery({
        queryKey: getLiveAnalysisEnabledKey(),
        queryFn: () => getLiveAnalysisEnabled(),
        enabled: !!user,
    });
};

export const useEnableLiveAnalysis = () => {
    return useMutation({
        mutationFn: () => apiClient.put(ApiConfig.path('/api/v1/live-feedback/enabled'), { enabled: true }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: getLiveAnalysisEnabledKey() });
        },
    });
};

export const useDisableLiveAnalysis = () => {
    return useMutation({
        mutationFn: () => apiClient.put(ApiConfig.path('/api/v1/live-feedback/enabled'), { enabled: false }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: getLiveAnalysisEnabledKey() });
        },
    });
};
